import { makeStyles } from '@material-ui/core/styles';
import {
  blackColor,
  btDarkOrange,
  btGreenColor,
  btLightOrange,
  btMediumGrayColor,
  grayColor,
  pinterestColor,
  secondaryColor,
  secondaryLightBlue,
  secondaryLightBlue200,
  webPrimaryColor,
  webSecondaryColor,
  welcomeBlue,
  whiteColor,
} from '../../assets/jss/nextjs-material-kit-pro';

const useStyles = makeStyles((theme) => ({
  plannerContainer: {
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  greetingContainer: {
    [theme.breakpoints.up('md')]: {
      width: '1320px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '-20px',
    },
  },
  inactiveSubLabel: {
    color: btLightOrange,
    backgroundColor: 'transparent',
    textAlign: 'left',
    // textTransform: 'none',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.40rem',
      lineHeight: '1.95rem',
      margin: '-20px 0 25px 100px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.40rem',
      lineHeight: '1.65rem',
      margin: '-5px 0 5px 20px',
    },
  },
  welcome: {
    color: whiteColor,
    backgroundColor: welcomeBlue,
    textAlign: 'left',
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
      fontSize: '3.00rem',
      lineHeight: '5.00rem',
      margin: '25px 10px 10px 100px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2.00rem',
      lineHeight: '3.85rem',
      margin: '5px 0 10px 20px',
    },
  },
  adminWelcome: {
    fontSize: '1.188rem',
    color: whiteColor,
    backgroundColor: welcomeBlue,
    textAlign: 'left',
    [theme.breakpoints.up('md')]: {
      margin: '5px 10px 10px 20px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '5px 0 10px 20px',
    },
  },
  alumniWelcome: {
    fontSize: '1.188rem',
    lineHeight: '1.625rem',
    color: whiteColor,
    backgroundColor: welcomeBlue,
    textAlign: 'left',
    [theme.breakpoints.up('md')]: {
      margin: '25px 10px 10px 10px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '0 0 25px 20px',
    },
  },
  oldStyleWelcome: {
    fontSize: '1.188rem',
    color: webSecondaryColor,
    textAlign: 'right',
    [theme.breakpoints.up('md')]: {
      margin: '25px 10px 10px 10px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '5px 0 10px 0',
    },
  },
  oldStyleAdminWelcome: {
    fontSize: '1.188rem',
    color: webSecondaryColor,
    textAlign: 'right',
    [theme.breakpoints.up('md')]: {
      margin: '5px 10px 10px 20px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '5px 0 10px 0',
    },
  },
  oldStyleAlumniWelcome: {
    fontSize: '1.188rem',
    lineHeight: '1.625rem',
    color: webSecondaryColor,
    textAlign: 'left',
    [theme.breakpoints.up('md')]: {
      margin: '25px 10px 10px 10px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '0 0 25px 0',
    },
  },
  alumniIntro: {
    margin: '2% 5% 10px 5%',
    fontSize: '1.063rem',
    lineHeight: '1.513rem',
    color: webPrimaryColor,
    textAlign: 'left',
  },
  menu: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bannerContent: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  pageBanner: {
    backgroundColor: secondaryLightBlue,
    [theme.breakpoints.up('md')]: {
      margin: '-1px 0 0 0',
      width: '100%',
      height: '230px',
      paddingTop: '10px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '-20px 0 0 0',
      width: '100%',
      height: '255px',
      paddingTop: '30px',
    },
  },
  checklistPageBanner: {
    backgroundColor: secondaryLightBlue,
    [theme.breakpoints.up('md')]: {
      margin: '-1px 0 0 0',
      width: '100%',
      height: '330px',
      paddingTop: '10px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '-20px 0 20px 0',
      width: '100%',
      height: '350px',
      paddingTop: '30px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '-20px 0 20px 0',
      width: '100%',
      height: '450px',
      paddingTop: '30px',
    },
  },
  subPageBannerGrid: {
    [theme.breakpoints.up('md')]: {
      margin: '-1px 0 0 0',
      width: '100%',
      height: '220px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '-20px 0 0 0',
      width: '100%',
      height: '240px',
    },
  },
  subPageContainer: {
    [theme.breakpoints.up('md')]: {
      width: '100%',
      marginTop: '-1px',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: '-20px',
    },
  },
  centerForm: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  centerHomeCards: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '50px',
  },
  homeHeader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {},
    [theme.breakpoints.down('md')]: {
      marginTop: '35px',
    },
  },
  workbookCenterMenu: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '50px',
    [theme.breakpoints.up('md')]: {
      // paddingLeft: '0',
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '-20px',
    },
  },
  menuRestricted: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '1320px',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  oldStyleMenu: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0 30px',
  },
  subMenu: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0 30px',
  },
  menuTitle: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontSize: '1.25rem',
    textAlign: 'left',
    margin: '20px 0 0 0',
  },
  menuDesc: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.063rem',
    textAlign: 'center',
    padding: '5px',
    color: webPrimaryColor,
  },
  appSubmittedDate: {
    fontSize: '1.50rem',
    color: webPrimaryColor,
    margin: '15px 0 50px 0',
    padding: 10,
    textAlign: 'center',
  },
  submittedDateLabel: {
    fontSize: '1.00rem',
    color: webPrimaryColor,
    margin: '15px 0 50px 0',
    padding: 10,
    textAlign: 'center',
  },
  recommendationDates: {
    fontSize: '1.50rem',
    color: webPrimaryColor,
    margin: '15px 0',
    padding: 10,
  },
  helpSubmittedDate: {
    fontSize: '1.50rem',
    color: webPrimaryColor,
    margin: '10px 0 8px 0',
    padding: 10,
    textAlign: 'center',
  },
  appStatus: {
    fontSize: '1.188rem',
    color: webPrimaryColor,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  warningStatusIcon: {
    fontSize: 20,
    color: secondaryColor,
  },
  appStatusDate: {
    fontSize: '1.188rem',
    position: 'relative',
    bottom: '5px',
    paddingLeft: 25,
  },
  statusBottom: {
    marginLeft: 10,
    position: 'absolute',
    bottom: '20px',
    left: '15%',
  },
  breadcrumbs: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      zIndex: 100,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      width: '1320px',
      padding: '30px 0 0 0',
    },
  },
  breadCrumbLink: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    fontSize: '0.80rem',
    cursor: 'pointer',
    '&:hover,&:focus': {
      textDecoration: 'underline',
    },
    color: grayColor,
  },
  breadCrumbText: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    color: secondaryColor,
    fontSize: '0.80rem',
  },
  alignCrumb: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  printMenuDesc: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'left',
    padding: '10px 5px 15px 5px',
    color: '#000',
  },
  headerDesc: {
    width: '100%',
    fontSize: '1.063rem',
    lineHeight: '1.313rem',
    padding: '15px 0 5px 0',
    textAlign: 'left',
    color: webPrimaryColor,
  },
  printHeaderDesc: {
    width: '90%',
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'left',
    padding: '10px 0',
    color: webPrimaryColor,
  },
  icon: {
    fontSize: '100px',
  },
  plannerIcons: {
    display: 'flex',
    justifyContent: 'center',
    align: 'flex-end',
    margin: '20px 10px -20px 0',
  },
  subPageHeaderWithIcons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardHeader: {
    color: webPrimaryColor,
    fontSize: '1.175rem',
    lineHeight: '1.5rem',
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: '10px',
  },
  iconText: {
    color: webPrimaryColor,
    fontSize: '1.188rem',
    lineHeight: '1.5rem',
    textAlign: 'center',
  },
  nav: {
    cursor: 'pointer',
  },
  homeIconSpace: {
    marginTop: 50,
  },
  card: {
    backgroundColor: whiteColor,
    [theme.breakpoints.down('md')]: {
      width: '273px',
      height: '260px',
    },
    [theme.breakpoints.up('md')]: {
      width: '273px',
      height: '260px',
    },
    margin: '0, 5px',
  },
  recommendationCard: {
    backgroundColor: whiteColor,
    [theme.breakpoints.down('md')]: {
      width: '285px',
      height: '275px',
    },
    [theme.breakpoints.up('md')]: {
      width: '235px',
      height: '275px',
    },
    margin: '0, 5px',
  },
  pageHeader: {
    margin: '10px 0 0 0',
  },
  pageTitle: {
    fontSize: '1.438rem',
    textAlign: 'left',
    fontWeight: 600,
  },
  oldStylePageTitle: {
    fontSize: '1.438rem',
    textAlign: 'left',
    fontWeight: 600,
  },
  pageIconText: {
    color: whiteColor,
    fontWeight: 600,
    marginLeft: 20,
  },
  printHeaderText: {
    color: '#000',
    fontWeight: 600,
  },
  homeIcon: {
    fontSize: '1.813rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    [theme.breakpoints.up('md')]: {
      marginBottom: 20,
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 40,
    },
  },
  pageHeading: {
    display: 'flex',
    justifyContent: 'center',
    padding: 30,
  },
  pageDesc: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'left',
    padding: '10px 5px 15px 5px',
    color: '#000',
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  breadcrumb: {
    padding: '18px 0 40px 10px',
    width: '100%',
    maxWidth: {
      xs: '380px',
      sm: '540px',
      md: '868px',
      lg: '1320px',
      xl: '1320px',
    },
  },
  addIcon: {
    color: webPrimaryColor,
    fontSize: '5.00rem',
    marginTop: 50,
    textAlign: 'center',
  },
  addSection: {
    display: 'flex',
    justifyContent: 'center',
  },
  error: {
    fontSize: '1.05rem',
    color: '#FA0000',
    fontWeight: 600,
    marginTop: 15,
  },
  notification: {
    fontSize: '1.10rem',
    color: btDarkOrange,
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
      margin: '85px 20px 35px 20px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '85px 0 35px -15px',
    },
  },
  returnNote: {
    fontSize: '1.238rem',
    color: '#FFD700',
    marginBottom: 5,
  },
  noApps: {
    fontSize: '1.088rem',
    marginTop: 50,
  },
  contactCard: {
    height: '180px',
    minHeight: '180px',
    margin: '0, 20px',
  },
  contact: {
    width: '100%',
    position: 'relative',
    top: 180,
  },
  contactInfoLabel: {
    color: whiteColor,
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
      lineHeight: '2.0rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.05rem',
      lineHeight: '1.35rem',
    },
  },
  oldStyleContactInfoLabel: {
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: webPrimaryColor,
    fontWeight: 600,
  },
  contactInfo: {
    color: whiteColor,
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
      lineHeight: '2.0rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.25rem',
      lineHeight: '1.75rem',
    },
  },
  subPageContactInfoLabel: {
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: '#fff',
    fontWeight: 600,
  },
  subPageContactInfo: {
    fontSize: '1rem',
    color: '#fff',
    lineHeight: '1.25rem',
    marginRight: 20,
  },
  oldStyleContactInfo: {
    fontSize: '1rem',
    color: webPrimaryColor,
    lineHeight: '1.25rem',
    verticalAlign: 'middle',
    marginRight: 20,
  },
  helpOptionsList: {
    color: webPrimaryColor,
    fontSize: '0.90rem',
    textAlign: 'center',
    fontStyle: 'italic',
  },
  cardIcon: {
    position: 'absolute',
    top: '-55px',
    left: '28%',
  },
  pageIcon: {
    [theme.breakpoints.up('md')]: {
      width: '10%',
      marginRight: '15px',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  cardBody: {
    padding: '35px 10px',
  },
  headerCard: {
    marginBottom: 10,
    padding: '20px',
  },
  cardContainer: {
    alignItems: 'center',
  },
  fullWidthBanner: {
    backgroundColor: welcomeBlue,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      marginTop: '-5px',
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '-20px',
      width: '100%',
    },
  },
  homeBannerContent: {
    [theme.breakpoints.up('md')]: {},
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  welcomeGrid: {
    backgroundColor: 'transparent',
    marginTop: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      width: '1320px',
      height: '380px',
      // padding: '150px 10px 0 100px',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '380px',
      // padding: '75px 10px 0 10px',
    },
  },
  seniorGrid: {
    marginTop: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      width: '100%',
      height: '100%',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '100%',
    },
  },
  adminWelcomeGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '100px',
      alignItems: 'flex-end',
      marginTop: '25px',
    },
    [theme.breakpoints.down('md')]: {
      height: '50px',
      alignItems: 'flex-start',
      marginBottom: 30,
    },
  },
  alumniWelcomeGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '100px',
      alignItems: 'center',
    },
    [theme.breakpoints.down('md')]: {
      height: '50px',
      alignItems: 'center',
      marginBottom: 100,
    },
  },
  oldStyleWelcomeGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '100px',
      alignItems: 'flex-end',
      marginTop: '25px',
    },
    [theme.breakpoints.down('md')]: {
      height: '50px',
      alignItems: 'flex-start',
    },
  },
  oldStyleAdminWelcomeGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '100px',
      alignItems: 'flex-end',
      marginTop: '25px',
    },
    [theme.breakpoints.down('md')]: {
      height: '50px',
      alignItems: 'flex-start',
      marginBottom: 30,
    },
  },
  oldStyleAlumniWelcomeGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '100px',
      alignItems: 'center',
      marginTop: '25px',
    },
    [theme.breakpoints.down('md')]: {
      height: '50px',
      alignItems: 'center',
      marginBottom: 100,
    },
  },
  oldStyleSpecialistGrid: {
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      marginTop: '25px',
      borderLeft: `1px solid ${secondaryColor}`,
      padding: '10px 10px 0 20px !important',
    },
    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-start',
    },
  },
  subPageBanner: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    [theme.breakpoints.up('md')]: {
      width: '100%',
      height: '130px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '10px',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  },
  subPageBannerTitle: {
    fontSize: '1.188rem',
    color: '#fff',
    width: '95%',
    padding: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      margin: '10px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '5px 0 10px 0',
    },
  },
  subPageSpecialistGrid: {
    [theme.breakpoints.up('md')]: {
      marginTop: '25px',
      borderLeft: `1px solid ${secondaryColor}`,
      padding: '10px 10px 0 20px !important',
    },
    [theme.breakpoints.down('md')]: {
      margin: '80px 0 5px 30px',
    },
  },
  specialistGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '85%',
    [theme.breakpoints.up('md')]: {
      margin: '10px 0 10px 100px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '10px 0 10px 20px',
    },
  },
  alumniContactButtonGrid: {
    margin: '50px 0 0 100px',
  },
  footerContact: {
    fontSize: '1.00rem',
    color: webPrimaryColor,
    width: '100%',
    marginTop: 20,
  },
  footerMargin: {
    padding: '0 10% 0 10%',
  },
  footerContactInfo: {
    color: webPrimaryColor,
    fontWeight: 500,
    fontSize: '1.00rem',
    lineHeight: '1.35rem',
    [theme.breakpoints.up('md')]: {
      padding: '5px 5%',
    },
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      padding: '5px 0',
    },
  },
  version: {
    color: btMediumGrayColor,
    fontWeight: 500,
    fontSize: '0.80rem',
    lineHeight: '1.00rem',
    [theme.breakpoints.up('md')]: {
      padding: '10px 15% 0 5%',
    },
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      padding: '10px 0',
    },
  },
  watermarkBackground: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '-10%',
      marginRight: '-10%',
      height: '155%',
      opacity: '.1',
      display: 'block',
    },
  },
  cardGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      padding: '2% 5% !important',
      gap: '40px 20px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '25px 10px !important',
      gap: '10px 10px',
    },
  },
  footerLink: {
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: '0.90rem',
    lineHeight: '1.10rem',
    textDecoration: 'underline',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      padding: '5px 0 2px 0',
    },
    [theme.breakpoints.up('md')]: {
      padding: '5px 15%',
    },
  },
  footerTitle: {
    textTransform: 'uppercase',
    fontSize: '1.20rem',
    fontWeight: 400,
    lineHeight: '1.649rem',
    color: webSecondaryColor,
    fontFamily: '"Roboto Slab", "Times New Roman", serif',
    [theme.breakpoints.up('md')]: {
      padding: '5px 5%',
    },
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      padding: '15px 0 5px 0',
    },
  },
  applicationArea: {
    fontSize: '1.00rem',
    lineHeight: '1.25rem',
    color: webSecondaryColor,
  },
  warning: {
    backgroundColor: '#fdb515',
    color: 'black',
  },
  moduleGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '40px 20px',
    padding: '30px 0 !important',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      width: '95%',
      marginLeft: '15px',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      width: '1320px',
    },
  },
  moduleCard: {
    backgroundColor: whiteColor,
    position: 'relative',

    '&:hover': {
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, .25)',
      '--tw-scale-x': '1.05',
      '--tw-scale-y': '1.05',
      '& $moduleName': {
        color: 'rgba(66, 152, 181, 1)',
      },
    },

    [theme.breakpoints.down('md')]: {
      width: '350px',
      height: '345px',
    },
    [theme.breakpoints.up('md')]: {
      width: '350px',
      height: '345px',
    },
    margin: '0, 5px',
  },
  courseCard: {
    backgroundColor: whiteColor,
    position: 'relative',
    '&:hover': {
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, .25)',
      '--tw-scale-x': '1.05',
      '--tw-scale-y': '1.05',
      '& $courseCardBody': {
        backgroundColor: 'rgba(130, 145, 29, 1)',
      },
      '& $courseName': {
        color: whiteColor,
      },
    },
    [theme.breakpoints.down('md')]: {
      width: '350px',
      height: '220px',
    },
    [theme.breakpoints.up('md')]: {
      width: '350px',
      height: '220px',
    },
    margin: '0, 5px',
  },
  moduleCardBody: {
    padding: '5px 5px',
  },
  courseCardBody: {
    padding: '5px 5px',
    backgroundColor: 'rgba(183, 191, 16, 1)',
  },
  moduleActionContainer: {
    width: '100%',
    position: 'absolute',
    bottom: '1px',
  },
  moduleButtonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  courseButtonContainer: {
    borderTop: '1px dashed gray',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  moduleName: {
    color: webPrimaryColor,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.00rem',
      lineHeight: '1.250rem',
      fontWeight: 600,
      margin: '10px 5px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.125rem',
      lineHeight: '1.450rem',
      fontWeight: 600,
      margin: '10px 15px',
    },
  },
  courseName: {
    fontSize: '1.063rem',
    lineHeight: '1.2rem',
    fontWeight: 600,
    color: blackColor,
    margin: '10px',
    '&:hover,&:focus': {
      color: whiteColor,
    },
  },
  moduleCourseImageHeading: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  moduleCourseName: {
    fontSize: '1.10rem',
    fontWeight: 600,
    color: webPrimaryColor,
    padding: 10,
  },
  moduleCourseDescription: {
    padding: '15px 0',
  },
  adminStatusDisplay: {
    textTransform: 'uppercase',
    fontWeight: 600,
    height: '50px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  moduleCourseButtonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  header: {
    backgroundColor: secondaryLightBlue,
    padding: '20px',
    [theme.breakpoints.down('md')]: {
      margin: '-20px 0 0 0',
    },
    [theme.breakpoints.up('md')]: {
      margin: '-5px 0 0 0',
    },
  },
  checklistHeader: {
    backgroundColor: secondaryLightBlue,
    padding: '15px 0 0 0',
    [theme.breakpoints.down('md')]: {
      margin: '-20px 0 0 0',
    },
    [theme.breakpoints.up('md')]: {
      margin: '-5px 0 0 0',
    },
  },
  logoContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      display: 'inline-block',
    },
  },
  logo: {
    [theme.breakpoints.down('md')]: {
      width: '40%',
    },
    [theme.breakpoints.up('md')]: {
      width: '80%',
    },
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  headerText: {
    color: whiteColor,
    width: '100%',
  },
  title: {
    fontWeight: 700,
    marginBottom: '15px',
    color: whiteColor,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      fontSize: '1.475rem',
      lineHeight: '1.55rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '80%',
      fontSize: '1.875rem',
      lineHeight: '2.35rem',
    },
  },
  introduction: {
    fontFamily: '"Source Sans 3", Helvetica, Roboto, Arial, sans-serif',
    fontWeight: 400,
    color: whiteColor,
    [theme.breakpoints.down('md')]: {
      width: '90%',
      paddingBottom: '75px',
      fontSize: '1.00rem',
      lineHeight: '1.25rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '80%',
      paddingBottom: '50px',
      fontSize: '1.25rem',
      lineHeight: '1.45rem',
    },
  },
  description: {
    fontWeight: 400,
    color: '#000',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    margin: '5px',
    padding: '15px 15px 20px 15px',
  },
  stats: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',
    [theme.breakpoints.down('md')]: {
      width: '200px',
      height: '85px',
    },
    [theme.breakpoints.up('md')]: {
      width: '260px',
      height: '105px',
    },
  },
  stat: {
    backgroundColor: btDarkOrange,
    borderRadius: '6px',
    margin: 5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px !important',
    [theme.breakpoints.down('md')]: {
      width: '90px',
      height: '85px',
    },
    [theme.breakpoints.up('md')]: {
      width: '115px',
      height: '105px',
    },
  },
  statLabel: {
    color: '#fff',
    fontWeight: 600,
    margin: '0 5px 5px 5px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.00rem',
      lineHeight: '1.25rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.125rem',
      lineHeight: '1.35rem',
    },
  },
  statValue: {
    color: '#fff',

    fontWeight: 600,
    margin: '0 5px 5px 5px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '2.25rem',
      lineHeight: '2.45rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '3rem',
      lineHeight: '3.25rem',
    },
  },
  workbookButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      width: '150px',
    },
    [theme.breakpoints.up('md')]: {
      width: '150px',
    },
  },
  workbookWatchButton: {
    cursor: 'pointer',
    width: '180px',
  },
  workbookDisabledButton: {
    cursor: 'not-allowed',
    backgroundColor: grayColor,
    width: '180px',
  },
  comingSoon: {
    textTransform: 'uppercase',
    margin: '35px 0 5px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 700,
    fontFamily: '"Source Sans 3", Helvetica, Roboto, Arial, sans-serif',
    fontSize: '0.9rem',
    lineHeight: '1.15rem',
  },
  returnButton: {
    margin: '30px 10px 5px 10px',
    width: '210px',
  },
  moduleCenterHeader: {
    [theme.breakpoints.down('md')]: {
      paddingTop: '15px',
      paddingLeft: '10px',
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: '30px',
      paddingLeft: '40px',
    },
  },
  moduleArrowContainer: {
    padding: '30px 0 0 0',
  },
  moduleStatus: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: '10px 10px 5px 15px',
    fontSize: '.0.813rem',
    lineHeight: '1.35rem',
    cursor: 'pointer',
  },
  courseStatus: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: '10px 0 5px 0',
    fontSize: '.0.813rem',
    lineHeight: '0.95rem',
  },
  statusIcon: {
    marginRight: '5px',
    color: '#000',
  },
  statusIconAndText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: '5px',
    color: 'rgba(0, 85, 128, 1)',
  },
  statusLockedIconColor: {
    height: '18px',
    cursor: 'not-allowed',
    backgroundColor: grayColor,
  },
  statusIconColor: {
    height: '18px',
    // stroke: 'rgba(0, 85, 128, 1)',  (This doesn't work. I had to include the color in the .SVG file.)
  },
  statusTextColor: {
    padding: '2px 0 0 3px !important',
    color: 'rgba(0, 85, 128, 1)',
  },
  statusText: {
    color: '#000',
  },
  alignButtonText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerButton: {
    cursor: 'pointer',
    width: '185px',
    margin: '20px 0 0 0',
  },
  wideHeaderButton: {
    cursor: 'pointer',
    width: '230px',
    margin: '20px 0 0 0',
  },
  sectionHeading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: `"Roboto Slab", "Times New Roman", serif`,
    color: webPrimaryColor,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      margin: '10px 0 50px 0',
      fontSize: '1.55rem',
      lineHeight: '1.75rem',
      fontWeight: 700,
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
      margin: '40px auto',
      fontSize: '2.00rem',
      lineHeight: '2.50rem',
      fontWeight: 800,
    },
  },
  divider: {
    borderTop: '2px solid ' + webPrimaryColor,
    [theme.breakpoints.down('md')]: {
      margin: '20px 60px 30px 20px',
    },
    [theme.breakpoints.up('md')]: {
      margin: '10px 50px',
    },
  },
  sectionHeadingLeft: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontFamily: `"Roboto Slab", "Times New Roman", serif`,
    color: webPrimaryColor,
    [theme.breakpoints.down('md')]: {
      margin: '5px 5px 10px 5px',
      fontSize: '1.55rem',
      lineHeight: '1.75rem',
      fontWeight: 700,
    },
    [theme.breakpoints.up('md')]: {
      margin: '10px 30px 25px 30px',
      fontSize: '2.00rem',
      lineHeight: '2.50rem',
      fontWeight: 800,
    },
  },
  cardButton: {
    cursor: 'pointer',
    position: 'absolute',
    bottom: '10px',
    left: '20%',
    width: '165px',
  },
  tipsCardBody: {
    padding: '35px 10px',
  },
  tipsBackground: {
    backgroundColor: 'rgba(244, 244, 244, 1)',
    [theme.breakpoints.down('md')]: {
      width: '99%',
      padding: '10px',
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
      padding: '40px',
    },
  },
  tipsFrame: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      margin: '5px auto',
      width: '99%',
    },
    [theme.breakpoints.up('md')]: {
      margin: '5px auto',
      width: '1320px',
    },
  },
  tipsCard: {
    backgroundColor: whiteColor,
    margin: '0 auto',
    borderRadius: '20px',
    [theme.breakpoints.down('md')]: {
      width: '95%',
    },
    [theme.breakpoints.up('md')]: {
      width: '95%',
    },
  },
  notficationArea: {
    width: '100%',
    margin: '25px 0 25px 0',
  },
  returnedToastMessage: {
    fontSize: '1.05rem',
    backgroundColor: pinterestColor,
    color: whiteColor,
    fontWeight: 600,
    [theme.breakpoints.down('md')]: {
      width: '85%',
      margin: '5px auto 5px auto',
      padding: '10px',
    },
    [theme.breakpoints.up('md')]: {
      width: '70%',
      margin: '15px auto 10px auto',
      padding: '15px',
    },
  },
  alumniHeadline: {
    [theme.breakpoints.up('md')]: {
      width: '100%',
      padding: '30px',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '10px 0 10px 0',
    },
  },
  largeInfo: {
    textAlign: 'left',
  },
  largeInfoGold: {
    fontFamily: '"Roboto Slab", "Times New Roman", serif',
    color: 'rgba(242, 169, 0, 1)',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.55rem',
      lineHeight: '1.85rem',
      fontWeight: 700,
      width: '95%',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '3.00rem',
      lineHeight: '3.75rem',
      fontWeight: 800,
    },
  },
  largeInfoBlue: {
    fontFamily: '"Roboto Slab", "Times New Roman", serif',
    color: webPrimaryColor,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.55rem',
      lineHeight: '1.85rem',
      fontWeight: 700,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '3.00rem',
      lineHeight: '3.75rem',
      fontWeight: 800,
    },
  },
  smallInfo: {
    color: webPrimaryColor,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.10rem',
      lineHeight: '1.35rem',
      width: '90%',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.50rem',
      lineHeight: '2.20rem',
    },
  },
  centerMenu: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '50px',
  },
  resourcesBackground: {
    backgroundColor: secondaryLightBlue200,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '99%',
      margin: '10px 0 15px 0',
      padding: '10px 5px',
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
  },
  resources: {
    backgroundColor: secondaryLightBlue200,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '99%',
      margin: '10px 0 15px 0',
      padding: '10px 5px',
    },
    [theme.breakpoints.up('md')]: {
      width: '1320px',
      margin: '50px 0 25px 0',
      padding: '20px 65px',
    },
  },
  resourceMenu: {
    width: '99%',
    display: 'flex',
    justifyContent: 'center',
  },
  resourceHeader: {
    margin: '20px 0 15px 0',
    textTransform: 'uppercase',
    color: blackColor,
    fontSize: '1.5rem',
    lineHeight: '1.80rem',
    fontWeight: 700,
  },
  resourceGrid: {
    gap: '40px 20px',
    padding: '30px 0 !important',
    [theme.breakpoints.down('md')]: {
      width: '380px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      width: '1320px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  returnButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '380px',
    },
    [theme.breakpoints.up('md')]: {
      width: '90%',
    },
  },
  adminReturnButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      paddingRight: '40px',
      width: '380px',
      paddingTop: '-25px',
      paddingBottom: '30px',
    },
    [theme.breakpoints.up('md')]: {
      width: '1320px',
      paddingTop: '-35px',
      paddingBottom: '40px',
    },
  },
  resourceCard: {
    backgroundColor: whiteColor,
    padding: 0,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: '350px',
      height: '200px',
    },
    [theme.breakpoints.up('md')]: {
      width: '350px',
      height: '200px',
    },
    margin: '0, 5px',
  },
  resourceCardHeader: {
    padding: '5px 5px',
    height: '60px',
    backgroundColor: btLightOrange,
  },
  resourceName: {
    color: blackColor,
    fontSize: '1.125rem',
    lineHeight: '1.450rem',
    fontWeight: 600,
    margin: '10px 15px',
  },
  resourceCardBody: {
    padding: 0,
  },
  resourceDescription: {
    padding: '10px 15px',
    color: blackColor,
    fontSize: '0.90rem',
    lineHeight: '1.185rem',
  },
  resourceActions: {
    borderTop: '1px dashed darkgray',
    marginTop: '10px',
    width: '99%',
    position: 'absolute',
    bottom: '1px',
  },
  resourceButton: {
    cursor: 'pointer',
    backgroundColor: secondaryLightBlue,
    width: '120px',
  },
  navIcon: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      marginRight: '10px',
      marginTop: '-7px',
    },
    [theme.breakpoints.up('md')]: {
      marginRight: '10px',
    },
  },
  navReturnIcon: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      marginRight: '-15px',
      marginTop: '-4px',
    },
    [theme.breakpoints.up('md')]: {
      marginRight: '7px',
    },
  },
  cardCompletionStat: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    margin: '3px 0 3px 0',
    fontSize: '0.85rem',
    fontWeight: 600,
    color: btGreenColor,
  },
  restrictPageWidth: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '95%',
      margin: '5px 0',
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
      margin: '5px 0',
    },
  },
  circleIcon: {
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
  },
  headerHomeIcon: {
    marginLeft: '1px',
    color: welcomeBlue,
    fontSize: '1.813rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  workbookHeaderContent: {
    backgroundColor: secondaryLightBlue,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      margin: '-5px 0 0 0',
      padding: '30px 20px 0 20px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '-20px 0 0 0',
      padding: '30px 20px 20px 20px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '-20px 0 55px 0',
      padding: '30px 20px 0 20px',
    },
  },
  checklistIntroParagraph: {
    width: '100%',
    textAlign: 'left',
    color: whiteColor,
    minHeight: '170px',
    [theme.breakpoints.down('md')]: {
      fontSize: '.95rem',
      lineHeight: '1.225rem',
      padding: '15px 0 10px 0',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.05rem',
      lineHeight: '1.275rem',
      padding: '15px 0 20px 0',
    },
  },
  cardAlignBottom: {
    position: 'absolute',
    bottom: '20px',
  },
}));

export default useStyles;
